<template>
  <div class="title">
    <div class="logo"></div>
    <div style="color: #FFF;margin-left: 5px;font-size: 1rem;">{{ name }}</div>
    <div class="detail" @click="onClick">详情</div>
  </div>
</template>

<script>
export default {
  name: 'title',
  props: ['img', 'name', "callback"],
  methods: {
    onClick() {
      this.callback && this.callback();
    }
  }
}
</script>

<style>
.title {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background: url('~@/assets/image/title-background.png');
  height: 2rem;
  display: flex;
  align-items: center;
  padding: 0 5px;

.logo {
  width: 1rem;
  height: 1rem;
  mask-repeat: no-repeat;
  mask-size: 100% 100%;
  mask-image: url('~@/assets/image/triangle.png');
  background: rgb(0, 255, 185);
  border-radius: 0px;
}

.detail {
  font-size: 0.7rem;
  color: #fff;
  right: 1.5rem;
  position: absolute;
  color: rgb(0, 255, 185);
  cursor: pointer;
}

}
</style>